var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlackArrowR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 8,
  viewBox: "0 0 14 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.8892 0.982534C12.1822 0.689562 12.6572 0.689673 12.9501 0.982784C13.2427 1.27566 13.2426 1.75024 12.9499 2.04303L7.70277 7.29199C7.6102 7.38514 7.50012 7.45907 7.37887 7.50952C7.25762 7.55997 7.12759 7.58594 6.99627 7.58594C6.86494 7.58594 6.73491 7.55997 6.61366 7.50952C6.49241 7.45907 6.38233 7.38514 6.28977 7.29199L1.03986 2.04299C0.747104 1.75028 0.747084 1.27567 1.03981 0.98294C1.33251 0.690247 1.80705 0.690225 2.09977 0.982891L6.28766 5.17001C6.67819 5.56047 7.31131 5.56044 7.70181 5.16995L11.8892 0.982534Z",
  fill: "#171717"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlackArrowR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/black-arrow-r.699c8aefd4c550d2b6d3f6e05d67678c.svg";